export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      Result: 'success',
      LogInfo: [
        {
          LogId: 2,
          LocationId: 'location-00001',
          Nickname: 'アイラ１号',
          Reply: '相談したい',
          ReplyDt: '2020/12/01 12:00:06',
          Status: 2
        },
        {
          LogId: 1,
          LocationId: 'location-00002',
          Nickname: 'アイラ２号',
          Reply: '良いです',
          ReplyDt: '2020/12/01 12:00:06',
          Status: 0
        }
      ]
    }
  }
}